<template> 
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn  icon dark :disabled="loading" @click="close()">
                <v-icon large>close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                <span v-if="editData.AbsenceID > 0">Edit Absence</span>
                <span v-else>Add Absence</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-form ref="editForm" v-model="editValid">
            <v-layout class="dialog-content">
                <v-flex xs12 md10 offset-md1 mt-4>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-select :items="types" item-text="Name" item-value="AbsenceTypeID" v-model="editData.AbsenceType.AbsenceTypeID" label="Type" :rules="requiredTypeRule"></v-select>
                        </v-flex>
                        <v-flex xs12>
                            <v-menu
                            ref="menu1"
                            v-model="startTimeMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="startTime"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            max-width="290px"
                            min-width="290px">
                                <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="startTime"
                                    label="Start Time"
                                    prepend-icon="access_time"
                                    readonly
                                    :error="!validTimes"
                                    :error-messages="errorMsgs"
                                    :rules="requiredRule"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-time-picker
                                    v-if="startTimeMenu"
                                    v-model="startTime"
                                    full-width
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="startTimeMenu = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.menu1.save(startTime)">OK</v-btn>
                                </v-time-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12>
                            <v-menu
                            ref="menu2"
                            v-model="endTimeMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="endTime"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            max-width="290px"
                            min-width="290px">
                                <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="endTime"
                                    label="End Time"
                                    prepend-icon="access_time"
                                    :error="!validTimes"
                                    :error-messages="errorMsgs"
                                    readonly
                                    :rules="requiredRule"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-time-picker
                                    v-if="endTimeMenu"
                                    v-model="endTime"
                                    full-width
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="endTimeMenu = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="$refs.menu2.save(endTime)">OK</v-btn>
                                </v-time-picker>
                            </v-menu>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap class="dialog-action-buttons">
                        <v-flex xs12 sm6>
                            <v-btn block color="success" :disabled="!editValid || !validTimes" :loading="loading" @click="submit">
                                <span>Save</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-btn block color="error" :disabled="loading" @click="close()">
                                <span>Cancel</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12>
                            <v-alert :value="error != null" outline type="error">
                                <span style="white-space: pre-wrap;">{{ error }}</span>
                            </v-alert>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card>
</template>


<script>
import absenceApi from '@/api/absenceApi';
import attendanceApi from "@/api/attendanceApi";
import UtilService from '@/services/utilService.js';

export default {
    components: {
    },
    props: {
        editData: {
            required: true
        },
        types: {
            required: true
        },
        date: {
            required: true
        },
        attendanceID: {
            required: true
        }
    },
    data() {
        return {
            loading: false,
            error: null,
            editValid: false,
            requiredRule: [v => v.length > 0 || 'Required'],
            requiredTypeRule: [v => v > 0 || 'Required'],
            startTimeMenu: false,
            endTimeMenu: false,
            attendance: null
        }
    },
    computed: {
        attendanceDate() {
            return UtilService.formatDateYMD(this.date)
        },
        startTime: {
            get() {
                var dateTime = this.editData.StartTime;
                console.log(dateTime)
                if(dateTime == undefined){
                    return '00:00'
                }
                var obj = new Date(dateTime)
                let hrs = (obj.getHours().toString().length == 1 ? '0' : '')+obj.getHours();
                let mins = (obj.getMinutes().toString().length == 1 ? '0' : '')+obj.getMinutes();
                return hrs + ':' + mins
            },
            set(v) {
                console.log('set', v)
                this.editData.StartTime = this.attendanceDate + "T"+v
            }
        },
        endTime: {
            get() {
                var dateTime = this.editData.EndTime;
                console.log(dateTime)
                if(dateTime == undefined){
                    return '00:00'
                }
                var obj = new Date(dateTime)
                let hrs = (obj.getHours().toString().length == 1 ? '0' : '')+obj.getHours();
                let mins = (obj.getMinutes().toString().length == 1 ? '0' : '')+obj.getMinutes();
                return hrs + ':' + mins
            },
            set(v) {
                console.log('set', v)
                this.editData.EndTime = this.attendanceDate + "T"+v
            }
        },
        validTimes() {
            let start = new Date(this.editData.StartTime);
            let end = new Date(this.editData.EndTime);
            return start < end;
        },
        errorMsgs() {
            if(this.validTimes){
                return [];
            }
            return [ "Start time must be before End time" ]
        }
    },
    methods: {
        close() {
            this.error = null; 
            this.$emit("close");
        },
        async submit() {
            this.error = null;
            this.loading = true;

            try {
                let result = await absenceApi.saveAttendanceMemberAbsence(this.editData);
                console.log("save result", result)
                this.close();
            }
            catch(e) {
                console.log('in the catch', e)
                this.error = e
            }
            this.loading = false;
        },
    },
    async created() {
        this.loading = true;

        try {
            this.attendance = await attendanceApi.getAttendanceByID(this.attendanceID);
        } catch (error) {
            this.error = error;
        }

        this.loading = false;
    }
}
</script>